$(document).ready(function() {

  // General Message
  $('.generalmessage').prependTo('header');

  // customize footer email signup 
  function changeFooterSignup() {
    const signup = $('.footer .emailSignup');
    const label = signup.find('.emailSignupText');
    const input = signup.find('.inputFieldTextbox');
    const button = signup.find('.emailSubmitButton');

    label.replaceWith('<span class="footer-heading">Sign up for Douglas County Fair Deals & Updates</span>');
    input.val('');
    input.attr('placeholder', 'EMAIL ADDRESS:');
    button.text('Subscribe');
  }

  // move countdown aroud
  function positionCountdown() {
    const cd = $('#siteInfoBannerWidget');

    if ($('body').hasClass('homepage')) {
      cd.prependTo('.section-tier-one-inner');
    } else {
      cd.insertBefore('main.content');
    }
  }

  changeFooterSignup();
  positionCountdown();

  // more jumplink
  $('.homepage .more-jump-link').on('click', function() {
    $('html, body').animate({
      scrollTop: $(".section-tier-two").offset().top - 70
    }, 1000);
  });


  // update ticket button url
  const defaultTixBtnURL = $('.header .ticket').attr('href');
  $('.header .custom-buy-tickets-btn').attr('href', defaultTixBtnURL);

});
